import { render, staticRenderFns } from "./AddAdminOrder.vue?vue&type=template&id=7cb5a709&scoped=true&"
import script from "./AddAdminOrder.vue?vue&type=script&lang=js&"
export * from "./AddAdminOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb5a709",
  null
  
)

export default component.exports